/* eslint-disable react-hooks/exhaustive-deps --
   AppShell usa molti useEffect fetch-then-setState (fetch counter sidebar,
   founder check, ecc.) che sono un pattern legittimo React. Il refactor
   con useTransition+derived state è fuori scope per questa iter UI mobile. */
import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { api } from "@/lib/api";
import { isNative } from "@/lib/native";
import { BULK_GREETINGS_LABEL, BULK_GREETINGS_HINT } from "@/lib/labels";
import ProntoLogo from "@/components/ProntoLogo";
// iter 309 r2: OnboardingExperience deprecato, sostituito da OnboardingMagico.
// import OnboardingExperience from "@/components/OnboardingExperience";
import MandatoOnboardingModal from "@/components/MandatoOnboardingModal";
import SitoPersonaleIntroModal from "@/components/SitoPersonaleIntroModal";  // iter v32 r37u · User M1453
import EmailVerificationBanner from "@/components/EmailVerificationBanner";
import GlobalMicFab from "@/components/GlobalMicFab";
import LiveGenerationToaster from "@/components/LiveGenerationToaster";
// iter v33 r62 · CreatingAnnuncioBanner RIPRISTINATO. User: dopo Genera
// annuncio dal sopralluogo l'app portava dentro subito nello skeleton
// del PropertyDetail e sembrava rotta. Nuovo flusso: banner globale
// che monitora la readiness (ai_description LLM + foto attaccate),
// utente puo' navigare libero, tocca "Apri" quando pronto.
import CreatingAnnuncioBanner from "@/components/CreatingAnnuncioBanner";
// iter v29 r199 — IOSInstallBanner rimosso (Pronto ora è app nativa, niente PWA prompt)
import GlobalSearchPalette from "@/components/GlobalSearchPalette";
import BottomTabBar from "@/components/BottomTabBar";
import ErrorBoundary from "@/components/ErrorBoundary";
import CreditsBadge from "@/components/CreditsBadge";
import {
  House, ChartBar, Users, UserGear, Sparkle, Gift, Lightning,
  Camera, ArrowsLeftRight, Calculator, Plus, MagnifyingGlass, SignOut, List, X,
  CaretRight, CaretLeft, ChatCircleDots, Lightbulb, Broadcast, MapPin, Image as ImageIcon, Images as ImagesIcon,
  AddressBook, Buildings, FilmSlate, WhatsappLogo, DeviceMobile, Robot, Storefront,
  ArrowSquareIn, Archive, Coins, Handshake, Star, Heartbeat, HandHeart, InstagramLogo,
  Question, Globe,
} from "@phosphor-icons/react";

// iter v28 r175 — User M1093: «Ristrutturiamo il menu, c'è tanta roba in
// Strumenti, rendilo più semplice». 5 sezioni invece di 3:
//   1. Principale (cose di tutti i giorni)
//   2. Stima (3 voci legate alla stima del cliente)
//   3. Strumenti (creazione contenuti, snellito)
//   4. Agenzia & Conto (recensioni, agenzia, import, crediti, radar)
//   5. Prossime feature (placeholder)
// iter v29 r087 — Sidebar redesign: da 18 voci flat a 5 sezioni mentali.
// User feedback (test mobile): "tante cose, dove inizio?". Raggruppo per
// JOB-TO-BE-DONE dell'agente, non per nome tecnico delle feature:
//   1. Casa (orientamento) → Home, Assistente
//   2. Lavoro quotidiano (annunci · agenda · sopralluogo)
//   3. Clienti (contatti · WhatsApp campagne)
//   4. Materiali (TUTTO il lavoro visivo + portali in un unico gruppo;
//      "Editor foto" rinominato "Foto", "I miei contenuti" → "Archivio",
//      "Galleria" → fuso con Archivio. Sparisce il doppione "foto").
//   5. Acquisizione (stima · trovo proprietari · richieste ricevute)
//   6. Agenzia (la mia agenzia · recensioni · crediti già accessibile dal
//      footer sidebar)
//   7. Prossimamente (Radar · Network) — invariato
const NAV_ITEMS = [
  {
    section: null,
    items: [
      { to: "/dashboard", label: "Home", icon: House, end: true, hint: "Punto di partenza", badgeKey: "home_todos", badgeAlert: true },
      { to: "/dashboard/assistente", label: "Assistente", icon: Sparkle, hint: "Il tuo consulente · chiedi qualunque cosa", badge: "Nuovo", badgeAmber: true },
    ],
  },
  {
    section: "Annunci",
    items: [
      { to: "/dashboard/annunci", label: "I miei annunci", icon: House, badgeKey: "properties_count", hint: "Cantiere completo · foto, descrizione, vetrina, social, portali" },
      { to: "/dashboard/sopralluogo", label: "Sopralluogo live", icon: MapPin, hint: "Sul posto · parli, scatti, è fatto", desktopHidden: true },
      { to: "/dashboard/agenda", label: "Agenda", icon: ChatCircleDots, hint: "Visite, scadenze, note vocali" },
    ],
  },
  {
    section: "Clienti",
    items: [
      { to: "/dashboard/contatti", label: "Contatti", icon: AddressBook, hint: "Clienti · WhatsApp pronto" },
      { to: "/dashboard/contatti?bulk=1", label: BULK_GREETINGS_LABEL, icon: WhatsappLogo, hint: BULK_GREETINGS_HINT },
    ],
  },
  {
    section: "Materiali",
    items: [
      // iter v30 r136 — User M2003: «l'Editor social non serve fuori dall'annuncio,
      // toglilo dalla sidebar». L'editor resta accessibile dentro l'annuncio
      // (tab "Social" della scheda immobile). Per i post veloci si usa il
      // bottone "Condividi · crea post" sul menu kebab della card.
      { to: "/dashboard/foto", label: "Editor foto", icon: ImageIcon, hint: "Migliora · arreda · planimetria" },
      { to: "/dashboard/galleria", label: "Galleria", icon: ImagesIcon, hint: "Tutte le foto dei tuoi annunci · prima e dopo · download" },
      { to: "/dashboard/contenuti", label: "Archivio", icon: Archive, hint: "Tutti i post, reel, PDF stampabili generati · ri-scarica in 1 clic" },
      { to: "/dashboard/vetrina-agente", label: "Il tuo sito", icon: Globe, hint: "Il tuo sito personale al tuo nome · l'unico così in Italia, da mettere in bio Instagram", badge: "Pro", badgeAmber: true },
      { to: "/dashboard/portali", label: "Portali", icon: ArrowsLeftRight, hint: "Esporta su Idealista, Casa.it, Immobiliare.it" },
    ],
  },
  {
    section: "Acquisizione",
    items: [
      { to: "/dashboard/stima", label: "Calcolo stima", icon: Calculator, hint: "Stima OMI per qualunque casa · tool da agente" },
      { to: "/dashboard/landing", label: "Trovo proprietari", icon: Sparkle, hint: "La tua pagina + volantino · ricevi richieste di stima" },
      { to: "/dashboard/richieste-stima", label: "Richieste ricevute", icon: Calculator, hint: "Proprietari che ti hanno chiesto una stima", badge: "Nuovo", badgeAmber: true, badgeKey: "valuation_leads_new", badgeAlert: true },
    ],
  },
  {
    section: "Agenzia",
    items: [
      { to: "/dashboard/agenzia", label: "La mia agenzia", icon: Buildings, hint: "Multi-agente, feed XML, inviti, importa gestionale" },
      { to: "/dashboard/recensioni", label: "Recensioni", icon: Star, hint: "Le stelle dei tuoi clienti" },
    ],
  },
  {
    section: "Prossimamente",
    items: [
      { to: "/dashboard/radar", label: "Radar di zona", icon: Broadcast, badge: "In arrivo", badgeAmber: true, hint: "Cosa è successo nelle tue zone, ogni mattina" },
      { to: "/dashboard/futuro/network", label: "Network agenti", icon: Handshake, badge: "In arrivo", badgeAmber: true, hint: "Collabora con gli altri agenti Pronto · co-mediazione" },
    ],
  },
];

// Founder-only allowlist (mirrors backend routes/admin_stats.py).
const FOUNDER_EMAILS_ADMIN = new Set([
  "baigipp@gmail.com",
  "agenda1777617628@vista.it",
]);

// "Console founder" nascosta dalla sidebar iter 240 (decisione user: è ovvio
// che serve solo al founder, niente bisogno di sezione "Founder" visibile).
// Route /dashboard/admin resta accessibile via URL diretto (gated lato backend).
// iter v27 r4: user feedback «mettimi visibile solo a me una pagina di controllo».
// Riattivata: sezione "Founder" con voce "Pannello controllo" → /dashboard/admin.
const FOUNDER_NAV_ITEM = {
  section: "Founder",
  items: [
    {
      to: "/dashboard/admin",
      label: "Pannello controllo",
      icon: Heartbeat,
      hint: "Salute app: quota email Resend, errori client, abuse log, signups oggi · solo founder",
    },
    {
      to: "/dashboard/admin/budget",
      label: "Budget Universal Key",
      icon: Lightning,
      hint: "Quanto sta consumando la Universal Key Emergent · proiezione mensile e alert · solo founder",
    },
  ],
};

const initialsOf = (u) => (u?.name || u?.email || "?")
  .split(" ").map((w) => w[0]).join("").slice(0, 2).toUpperCase();

function NavLink({ to, label, icon: Icon, end, badge, badgeKey, badgeAmber, badgeAlert, hint, currentPath, onClick, counters, emphasize }) {
  const active = end ? currentPath === to : currentPath.startsWith(to) && currentPath !== "/dashboard";
  // Special: /dashboard root stays active for /dashboard exactly
  const isRoot = to === "/dashboard" && currentPath === "/dashboard";
  const isActive = isRoot || active;
  const dynamicCount = badgeKey && counters?.[badgeKey] ? counters[badgeKey] : 0;
  // iter v28 r180 — Se è badgeAlert (es. lead nuovi, todos), mostriamo un
  // pallino rosso con il numero accanto al badge statico esistente.
  // Altrimenti fallback al vecchio comportamento (badge numerico).
  const alertCount = badgeAlert && dynamicCount > 0 ? dynamicCount : null;
  const dynamicBadge = !badgeAlert && dynamicCount > 0 ? String(dynamicCount) : null;
  const badgeContent = badge || dynamicBadge;
  const [hintOpen, setHintOpen] = useState(false);

  const onHintClick = (e) => {
    e.preventDefault(); e.stopPropagation();
    setHintOpen((v) => !v);
  };

  return (
    <div className="relative">
      <Link
        to={to}
        onClick={onClick}
        title={hint || undefined}
        className={`group flex items-center gap-3 px-3 py-2 rounded-md text-[14px] transition-all ${
          isActive
            ? "bg-[#1C1C1A] text-white shadow-sm"
            : "text-[#3F3D38] hover:bg-[#EDEAE2]"
        }`}
        data-testid={`sidenav-${to.split("/").pop() || "home"}`}
      >
        <Icon size={16} weight={isActive ? "fill" : "regular"} className={isActive ? "text-white" : "text-[#7C8B6E]"} />
        {/* iter v28 r420 — User M1330: section "Stima" leggermente più visibile.
            `emphasize` aumenta il font-weight da default (400) a 600 e bumpa
            il size di mezzo px così la sezione spicca senza esagerare.
            iter v29 r221 — User: font sidebar leggermente più grande (+1px). */}
        <span className={`flex-1 truncate ${emphasize ? "font-semibold text-[14.5px]" : ""}`}>{label}</span>
        {/* iter v28 r180 — Alert badge (pallino rosso con N): segnala
            azioni pendenti dell'agente (lead nuovi, todos da fare).
            Si affianca al badge statico ("Nuovo"/"In arrivo") se presente. */}
        {alertCount !== null && (
          <span
            className={`inline-flex items-center justify-center min-w-[18px] h-[18px] px-1 rounded-full text-[10.5px] font-bold leading-none ${
              isActive
                ? "bg-white text-[#C24E4E]"
                : "bg-[#C24E4E] text-white"
            }`}
            data-testid={`sidenav-alert-${to.split("/").pop() || "home"}`}
            title={`${alertCount} ${alertCount === 1 ? "cosa da fare" : "cose da fare"}`}
          >
            {alertCount > 9 ? "9+" : alertCount}
          </span>
        )}
        {badgeContent && (
          <span className={`text-[9px] uppercase tracking-[0.05em] font-bold px-1.5 py-0.5 rounded ${
            isActive
              ? "bg-white/20 text-white"
              : badge === "NEW"
                ? "bg-[#C8A66B]/20 text-[#8C6F3D]"
                : badgeAmber
                  ? "bg-[#C8A66B] text-white"
                  : "bg-[#7C8B6E] text-white"
          }`}>{badgeContent}</span>
        )}
        {hint && (
          <button
            type="button"
            onClick={onHintClick}
            // iter v29 r002 — Su iOS Safari il <button> nativo veniva
            // renderizzato come capsula verticale anche con w-4 h-4 a causa
            // dell'appearance di default. Fix: appearance-none esplicito
            // + dimensioni 20×20 (più leggibili) + flex centratura forzata
            // su entrambi gli assi + line-height fisso per non far stirare
            // il glifo "?" verticalmente.
            className={`shrink-0 appearance-none flex items-center justify-center w-5 h-5 rounded-full border text-[10px] font-bold leading-none p-0 transition-all ${
              isActive
                ? "border-white/40 text-white/70 hover:bg-white/20"
                : "border-[#C8C5BC] text-[#9A968B] hover:border-[#7C8B6E] hover:text-[#7C8B6E]"
            }`}
            style={{ WebkitAppearance: "none", aspectRatio: "1 / 1", minWidth: 20, minHeight: 20 }}
            aria-label={`Cosa significa ${label}`}
            data-testid={`sidenav-hint-${to.split("/").pop() || "home"}`}
            tabIndex={-1}
          >
            ?
          </button>
        )}
      </Link>
      {hintOpen && hint && (
        <div
          className="mt-1 mx-3 px-3 py-2 rounded-md bg-[#FFFAEB] border border-[#F0E0B7] text-[11.5px] text-[#5A4A1F] leading-snug"
          onClick={() => setHintOpen(false)}
          data-testid={`sidenav-hint-popover-${to.split("/").pop() || "home"}`}
        >
          {hint}
        </div>
      )}
    </div>
  );
}

function PlanCard({ user }) {
  if (!user) return null;
  // BETA mode: every user has Pro included for free. The referral_pro_until
  // field is reused as the universal "extra credits" anchor — bumped by
  // referrals and submitted ideas. We expose those days here.
  let extraDays = 0;
  if (user.referral_pro_until) {
    const ms = new Date(user.referral_pro_until) - new Date();
    extraDays = Math.max(0, Math.ceil(ms / 86400000));
  }
  const hasCredits = extraDays > 0;
  return (
    <Link
      to="/dashboard/idee"
      className="block px-3 py-3 rounded-md bg-[#FAFAF7] border border-[#E5E7E0] hover:border-[#7C8B6E]/40 hover:shadow-sm transition-all group"
      data-testid="sidebar-plan-beta"
    >
      {hasCredits ? (
        <>
          <div className="text-[12px] text-[#1C1C1A] font-medium leading-snug">
            <span className="text-[#7C8B6E] font-bold">+{extraDays} {extraDays === 1 ? "giorno" : "giorni"} Pro</span> accumulati
          </div>
          <div className="text-[10.5px] text-[#6B6A65] mt-0.5">da inviti e idee proposte</div>
          <div className="mt-2 text-[11px] text-[#7C8B6E] font-medium flex items-center gap-1 group-hover:translate-x-0.5 transition-transform">
            Vedi crediti <CaretRight size={9} weight="bold" />
          </div>
        </>
      ) : (
        <>
          <div className="text-[12px] text-[#1C1C1A] font-medium leading-snug">
            Stiamo costruendola con voi.<br/>Cosa vorresti che facesse?
          </div>
          <div className="mt-2 text-[11px] text-[#7C8B6E] font-medium flex items-center gap-1 group-hover:translate-x-0.5 transition-transform">
            Proponi un&apos;idea <CaretRight size={9} weight="bold" />
          </div>
        </>
      )}
    </Link>
  );
}

export default function AppShell({ children, title, action, breadcrumb, counters: countersProp }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  // iter v28 r180 — counters auto-fetched dall'AppShell (badge "🔴" sulla
  // sidebar). Le pagine che passano `counters` come prop hanno la precedenza
  // (back-compat), altrimenti fetchiamo qui per avere il pallino visibile
  // ovunque l'utente sia nell'app.
  // iter v28 r231 — User M1147: «ogni tanto lampeggia la barra in parte al
  // logo». Causa: AppShell viene rimontato ad ogni navigazione (è dentro
  // ogni pagina, non sopra <Routes>). Ad ogni remount autoCounters partiva
  // da {} → badge nascosto → fetch ~500ms → badge ricompare = lampeggio.
  // Fix: cache in sessionStorage così al remount mostriamo subito l'ultimo
  // valore noto, e il refresh API avviene in background senza flash.
  // iter v28 r231 — Fix lampeggio: cache counters in sessionStorage keyed
  // per utente, così al remount AppShell mostra subito l'ultimo valore.
  const _COUNTERS_CACHE_KEY = `pronto:sidebar-counters-v1:${user?.user_id || "anon"}`;
  const [autoCounters, setAutoCounters] = useState(() => {
    if (typeof window === "undefined") return {};
    try {
      const raw = sessionStorage.getItem(_COUNTERS_CACHE_KEY);
      return raw ? JSON.parse(raw) : {};
    } catch { return {}; }
  });
  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        // 1. richieste stima nuove (valuation_request status=new)
        const leadsResp = await api.get("/leads").catch(() => ({ data: [] }));
        const leadsArr = Array.isArray(leadsResp.data) ? leadsResp.data : (leadsResp.data?.leads || []);
        const newValuations = leadsArr.filter(
          (l) => l.kind === "valuation_request" && (l.status || "new") === "new"
        ).length;

        // 2. Properties count (per badge "Annunci")
        const propsResp = await api.get("/properties").catch(() => ({ data: [] }));
        const props = (propsResp.data || []).filter((p) => !p.is_demo);

        // 3. Briefing per impegni scaduti (badge "Cosa fare oggi" su Home)
        const briefResp = await api.get("/agenda/briefing").catch(() => ({ data: null }));
        const brief = briefResp.data || {};
        const overdueCount = (brief.overdue || []).length;
        const hotContacts = (brief.hot_contacts || []).length;

        // Total task count per Home badge (somma di tutte le cose da fare,
        // capped a 9 per estetica del pallino — "9+" se sopra)
        const totalTodos = newValuations + overdueCount
          + props.filter(p => !p.public_url && (p.enhanced_count || 0) < (p.photo_count || 0)).length
          + (hotContacts > 0 ? 1 : 0)
          + props.filter(p => !p.public_url && p.ai_description).length;

        if (alive) {
          const next = {
            properties_count: props.length,
            valuation_leads_new: newValuations,
            home_todos: Math.min(totalTodos, 99),
          };
          setAutoCounters(next);
          try { sessionStorage.setItem(_COUNTERS_CACHE_KEY, JSON.stringify(next)); } catch { /* quota */ }
        }
      } catch {
        // silently ignore — i counter sono opzionali
      }
    })();
    return () => { alive = false; };
  }, [user?.user_id]);

  // Merge: prop wins, but fill blanks from auto.
  const counters = { ...autoCounters, ...(countersProp || {}) };
  // Founder-only nav: append admin console at bottom of sidebar.
  // iter v27 r4 — l'allowlist è gestita lato backend (env FOUNDER_EMAILS).
  // Il frontend chiede una volta a /api/admin/is-founder e cachea il flag.
  // Fallback: se l'endpoint fallisce, usiamo la lista hardcoded.
  const [isFounderBackend, setIsFounderBackend] = useState(null);
  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const { data } = await api.get("/admin/is-founder");
        if (alive) setIsFounderBackend(!!data?.is_founder);
      } catch {
        if (alive) setIsFounderBackend(false);
      }
    })();
    return () => { alive = false; };
  }, [user?.email]);
  const isFounder = isFounderBackend ?? FOUNDER_EMAILS_ADMIN.has((user?.email || "").toLowerCase());
  const navItems = isFounder && FOUNDER_NAV_ITEM ? [...NAV_ITEMS, FOUNDER_NAV_ITEM] : NAV_ITEMS;
  const location = useLocation();
  const [drawerOpen, setDrawerOpen] = useState(false);

  useEffect(() => {
    setDrawerOpen((prev) => (prev ? false : prev));
  }, [location.pathname]);

  // Tema dinamico — applica brand_color dell'agente come CSS variable
  // `--brand-accent` su <html> così tutta l'app si tinge col colore agenzia.
  useEffect(() => {
    const c = user?.brand_color;
    const root = document.documentElement;
    if (c && /^#[0-9A-Fa-f]{6}$/.test(c)) {
      root.style.setProperty("--brand-accent", c);
    } else {
      root.style.removeProperty("--brand-accent");
    }
  }, [user?.brand_color]);

  // iter v26 r15 — Repair one-shot delle foto importate dalla galleria
  // globale a un annuncio PRIMA del fix che mappava male restyle/staging
  // su enhanced_path invece di staged_path. Chiamato silenziosamente al
  // login (max una volta per sessione, via localStorage). L'endpoint è
  // idempotente: chiamarlo più volte non crea danni.
  useEffect(() => {
    if (!user?.user_id) return;
    const flagKey = `pronto:photos-repair-v26r15:${user.user_id}`;
    if (localStorage.getItem(flagKey)) return;
    (async () => {
      try {
        const { api } = await import("@/lib/api");
        await api.post("/photos/repair-imported-kind", {});
        localStorage.setItem(flagKey, "1");
      } catch (e) {
        // Silenzioso — se fallisce ritenta al prossimo login
        console.debug("repair-imported-kind skip", e?.message);
      }
    })();
  }, [user?.user_id]);

  return (
    <div className="min-h-screen bg-[#FAFAF7] flex">
      {/* Desktop Sidebar */}
      <aside className="hidden lg:flex w-60 shrink-0 flex-col bg-[#F5F4F0] border-r border-[#E8E5DE] sticky top-0 h-screen" data-testid="app-sidebar">
        <div className="px-4 pt-5 pb-3">
          <Link to="/dashboard" className="inline-flex items-center gap-1" data-testid="sidebar-brand">
            <img
              src="/logo/mark-symbol.png"
              alt="Pronto"
              className="h-9 w-9 select-none"
              draggable="false"
              style={{ filter: "drop-shadow(0 1px 1px rgba(0,0,0,0.12)) contrast(1.08) saturate(1.05)" }}
            />
          </Link>
        </div>

        {/* Search bar nascosta iter 240: decisione user, non funziona davvero
            (cliccando porta solo a /dashboard, niente palette globale).
            Riattivare quando avremo una vera Cmd+K palette con search across
            properties + contacts + quick-links. */}
        {/*
        <div className="px-3 pb-3">
          <button
            onClick={() => navigate("/dashboard")}
            className="w-full flex items-center gap-2 px-2.5 py-1.5 bg-white border border-[#E8E5DE] rounded-md text-[12.5px] text-[#9A968B] hover:border-[#C8C5BD] transition-colors"
            data-testid="sidebar-search"
          >
            <MagnifyingGlass size={13} />
            <span>Cerca</span>
            <span className="ml-auto text-[10px] text-[#9CA3AF] border border-[#E8E5DE] px-1.5 py-0.5 rounded bg-[#FAFAF7]">⌘K</span>
          </button>
        </div>
        */}

        <nav className="flex-1 overflow-y-auto px-3 space-y-4 pb-3">
          {navItems.map((group, gIdx) => (
            <div key={group.section || `g-${gIdx}`}>
              {group.section && (
                <div className="px-3 mb-1.5 text-[9px] uppercase tracking-[0.22em] text-[#9A968B] font-semibold">{group.section}</div>
              )}
              <div className="space-y-0.5">
                {group.items.filter((it) => !it.desktopHidden).map((it) => (
                  <NavLink key={it.to} {...it} emphasize={it.emphasize ?? group.emphasize} currentPath={location.pathname} counters={counters} />
                ))}
              </div>
            </div>
          ))}
        </nav>

        <div className="p-3 space-y-2 border-t border-[#E8E5DE]">
          <PlanCard user={user} />
          {(() => {
            const fields = [user?.agency_name, (user?.agency_phone && user?.agency_email), user?.agency_logo_url, user?.agency_address];
            const filled = fields.filter(Boolean).length;
            const total = fields.length;
            const pct = total > 0 ? Math.round((filled / total) * 100) : 100;
            const incomplete = pct < 100 && user;
            return (
              <Link
                to="/dashboard/profile"
                className="flex items-center gap-2.5 px-2 py-2 rounded-md hover:bg-[#EDEAE2] transition-colors group"
                data-testid="sidebar-profile"
                title={incomplete ? `Profilo ${pct}% — completalo` : "Profilo"}
              >
                <div className="relative shrink-0">
                  {user?.picture ? (
                    <img src={user.picture} alt="" className="w-7 h-7 rounded-full object-cover" />
                  ) : (
                    <div className="w-7 h-7 rounded-full bg-gradient-to-br from-[#7C8B6E] to-[#5A6B4D] text-white flex items-center justify-center text-[10px] font-semibold">
                      {initialsOf(user)}
                    </div>
                  )}
                  {incomplete && (
                    <span
                      className="absolute -top-0.5 -right-0.5 w-2.5 h-2.5 bg-[#C8A66B] border-2 border-[#F5F4F0] rounded-full"
                      data-testid="profile-incomplete-dot"
                      aria-label="Profilo incompleto"
                    />
                  )}
                </div>
                <div className="min-w-0 flex-1">
                  <div className="text-[12px] font-medium truncate text-[#1C1C1A]">{user?.name || "Profilo"}</div>
                  {incomplete ? (
                    <div className="text-[10.5px] text-[#8C6F3D] truncate font-medium inline-flex items-center gap-1">
                      Completa il profilo <span aria-hidden="true">→</span>
                    </div>
                  ) : (
                    <div className="text-[10.5px] text-[#9A968B] truncate">{user?.email}</div>
                  )}
                </div>
                <span
                  className="shrink-0 w-7 h-7 rounded-full bg-[#EDEAE2] group-hover:bg-[#7C8B6E] flex items-center justify-center transition-colors"
                  aria-hidden="true"
                >
                  <UserGear size={15} weight="fill" className="text-[#6B6A65] group-hover:text-white transition-colors" />
                </span>
              </Link>
            );
          })()}
          <Link
            to="/dashboard/crediti"
            className="w-full flex items-center gap-2 px-2 py-1.5 rounded-md text-[12px] text-[#9A968B] hover:bg-[#EDEAE2] hover:text-[#1C1C1A] transition-colors"
            data-testid="sidebar-crediti"
          >
            <Coins size={13} weight="fill" /> Crediti e piano
          </Link>
          <button
            onClick={() => {
              // iter 309 r3: punta a OnboardingMagico (vedi nota in fondo).
              try {
                localStorage.removeItem("pronto_onboarding_magico");
                localStorage.removeItem("pronto_onboarding_v1");
                localStorage.removeItem("pronto.welcome-tour.v2.seen");
              } catch (_e) { /* ignore */ }
              navigate("/dashboard?onboarding=1");
            }}
            className="w-full flex items-center gap-2 px-2 py-1.5 rounded-md text-[12px] text-[#9A968B] hover:bg-[#EDEAE2] hover:text-[#1C1C1A] transition-colors"
            data-testid="sidebar-replay-tour"
            title="Rivedi il tour di benvenuto"
          >
            <Sparkle size={13} weight="fill" /> Tour guidato
          </button>
          {/* iter v29 r233 — Centro aiuto a prova di stupido (User M1389) */}
          <Link
            to="/dashboard/aiuto"
            className="w-full flex items-center gap-2 px-2 py-1.5 rounded-md text-[12px] text-[#9A968B] hover:bg-[#EDEAE2] hover:text-[#1C1C1A] transition-colors"
            data-testid="sidebar-aiuto"
            title="Come si fa cosa — guide brevi"
          >
            <Question size={13} weight="duotone" /> Aiuto
          </Link>
          <button
            onClick={async () => { await logout(); navigate("/"); }}
            className="w-full flex items-center gap-2 px-2 py-1.5 rounded-md text-[12px] text-[#9A968B] hover:bg-[#EDEAE2] hover:text-[#1C1C1A] transition-colors"
            data-testid="sidebar-logout"
          >
            <SignOut size={13} /> Esci
          </button>
          {/* iter v29 r124 · link Instagram */}
          <a
            href="https://www.instagram.com/prontoimmo.it"
            target="_blank"
            rel="noopener noreferrer"
            className="w-full flex items-center gap-2 px-2 py-1.5 rounded-md text-[12px] text-[#9A968B] hover:bg-[#EDEAE2] hover:text-[#1C1C1A] transition-colors mt-1"
            data-testid="sidebar-instagram"
            title="Seguici su Instagram"
          >
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#7C8B6E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="20" height="20" x="2" y="2" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" x2="17.51" y1="6.5" y2="6.5"/></svg>
            @prontoimmo.it
          </a>
        </div>
      </aside>

      {/* Mobile drawer */}
      {drawerOpen && (
        <div
          className="lg:hidden fixed inset-0 z-50 bg-[#FAFAF7] flex flex-col"
          data-testid="app-drawer"
          style={isNative ? {
            // iter v29 r207 — safe-area iOS: senza padding-top il drawer
            // partiva sotto la Dynamic Island/orologio.
            paddingTop: "env(safe-area-inset-top)",
            paddingBottom: "env(safe-area-inset-bottom)",
          } : undefined}
        >
          {/* Header drawer (sticky) */}
          <div className="h-16 flex items-center justify-between px-5 border-b border-[#E8E5DE] flex-shrink-0">
            <Link to="/dashboard" onClick={() => setDrawerOpen(false)} className="flex items-center gap-1">
              <img
                src="/logo/mark-symbol.png"
                alt="Pronto"
                className="h-8 w-8 select-none"
                draggable="false"
              />
            </Link>
            <button onClick={() => setDrawerOpen(false)} aria-label="Chiudi" data-testid="drawer-close-btn" className="p-2 -mr-2"><X size={22} /></button>
          </div>

          {/* Body — scrollable */}
          <nav className="flex-1 overflow-y-auto px-5 pt-4 pb-6 space-y-4">
            {/* Profile up top — primary access for the agent */}
            <Link
              to="/dashboard/profile"
              onClick={() => setDrawerOpen(false)}
              className="flex items-center gap-3 px-3 py-3 bg-white border border-[#E8E5DE] rounded-xl hover:border-[#7C8B6E] transition-colors"
              data-testid="drawer-profile"
            >
              {user?.picture ? (
                <img src={user.picture} alt="" className="w-10 h-10 rounded-full object-cover flex-shrink-0" />
              ) : (
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#7C8B6E] to-[#5A6B4D] text-white flex items-center justify-center text-[12px] font-semibold flex-shrink-0">
                  {initialsOf(user)}
                </div>
              )}
              <div className="min-w-0 flex-1">
                <div className="text-[14px] font-medium truncate text-[#1C1C1A]">{user?.name || "Il mio profilo"}</div>
                <div className="text-[11.5px] text-[#9A968B] truncate">{user?.email}</div>
              </div>
              <span
                className="shrink-0 w-9 h-9 rounded-full bg-[#EDEAE2] flex items-center justify-center"
                aria-hidden="true"
              >
                <UserGear size={18} weight="fill" className="text-[#7C8B6E]" />
              </span>
            </Link>

            {/* Nav groups */}
            {navItems.map((group, gIdx) => (
              <div key={group.section || `mg-${gIdx}`}>
                {group.section && (
                  <div className="px-2 mb-2 text-[9px] uppercase tracking-[0.22em] text-[#9A968B] font-semibold">{group.section}</div>
                )}
                <div className="space-y-1">
                  {group.items.map((it) => (
                    <NavLink key={it.to} {...it} emphasize={it.emphasize ?? group.emphasize} currentPath={location.pathname} counters={counters} onClick={() => setDrawerOpen(false)} />
                  ))}
                </div>
              </div>
            ))}

            {/* Plan banner */}
            <div className="pt-4 border-t border-[#E8E5DE]">
              <PlanCard user={user} />
            </div>

            {/* Tour guidato — sempre riavviabile.
                iter 309 r3: ora punta a OnboardingMagico via ?onboarding=1
                (OnboardingExperience è stato disabilitato in iter 309 r2). */}
            <button
              onClick={() => {
                try {
                  localStorage.removeItem("pronto_onboarding_magico");
                  localStorage.removeItem("pronto_onboarding_v1");
                  localStorage.removeItem("pronto.welcome-tour.v2.seen");
                } catch (_e) { /* ignore */ }
                setDrawerOpen(false);
                navigate("/dashboard?onboarding=1");
              }}
              className="w-full flex items-center gap-3 px-3 py-3 rounded-md text-[13px] text-[#7C8B6E] hover:bg-[#F1F4ED] hover:text-[#1C1C1A] transition-colors"
              data-testid="drawer-replay-tour"
            >
              <Sparkle size={16} weight="fill" /> Tour guidato
            </button>

            {/* iter v29 r233 — Centro aiuto a prova di stupido */}
            <Link
              to="/dashboard/aiuto"
              onClick={() => setDrawerOpen(false)}
              className="w-full flex items-center gap-3 px-3 py-3 rounded-md text-[13px] text-[#7C8B6E] hover:bg-[#F1F4ED] hover:text-[#1C1C1A] transition-colors"
              data-testid="drawer-aiuto"
            >
              <Question size={16} weight="duotone" /> Aiuto
            </Link>

            {/* Logout — always at the very bottom */}
            <button
              onClick={async () => { setDrawerOpen(false); await logout(); navigate("/"); }}
              className="w-full flex items-center gap-3 px-3 py-3 rounded-md text-[13px] text-[#9A968B] hover:bg-[#F1F4ED] hover:text-[#1C1C1A] transition-colors"
              data-testid="drawer-logout"
            >
              <SignOut size={16} /> Esci
            </button>

            {/* iter v29 r124 · Instagram link drawer mobile */}
            <a
              href="https://www.instagram.com/prontoimmo.it"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => setDrawerOpen(false)}
              className="w-full flex items-center gap-3 px-3 py-3 rounded-md text-[13px] text-[#9A968B] hover:bg-[#F1F4ED] hover:text-[#1C1C1A] transition-colors"
              data-testid="drawer-instagram"
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#7C8B6E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="20" height="20" x="2" y="2" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" x2="17.51" y1="6.5" y2="6.5"/></svg>
              @prontoimmo.it
            </a>

            {/* Safe-area iOS bottom inset */}
            <div className="h-6" />
          </nav>
        </div>
      )}

      {/* Main content area */}
      <div className="flex-1 min-w-0 flex flex-col">
        {/* iter v29 r245 — User M1400: «niente contenuto sopra l'orario quando
            scrolli». Su iOS native un overlay FISSO copre l'area della status
            bar così, anche se il content fa overscroll/rubber-band, l'orologio
            resta su sfondo cream pulito (no flash di contenuto trasparente). */}
        {isNative && (
          <div
            aria-hidden="true"
            className="fixed top-0 left-0 right-0 bg-[#FAFAF7] z-[9998] pointer-events-none"
            style={{ height: "env(safe-area-inset-top)" }}
          />
        )}
        {/* Topbar */}
        <header
          className="sticky top-0 z-20 bg-[#FAFAF7]/85 backdrop-blur-sm border-b border-[#EAE7DF] h-14 lg:h-14 flex items-center justify-between px-4 lg:px-6 relative"
          style={isNative ? {
            paddingTop: "env(safe-area-inset-top)",
            height: "calc(44px + env(safe-area-inset-top))",
          } : undefined}
        >
          <div className="flex items-center gap-2 min-w-0 flex-1">
            <button
              onClick={() => setDrawerOpen(true)}
              className="lg:hidden p-2 -ml-2 text-[#1C1C1A]"
              aria-label="Menu"
              data-testid="topbar-menu-btn"
            >
              <List size={22} />
            </button>
            {/* Back button — globally available on every page except /dashboard root.
                iter 275: su pagine TOP-LEVEL (lista in sidebar) "Indietro" porta
                sempre a /dashboard invece di `navigate(-1)`. Motivo: l'utente
                aprendo p.es. Agenda dalla sidebar dopo essere stato in Editor
                foto si ritrovava buttato in Editor foto premendo Indietro —
                comportamento browser-standard ma totalmente disorientante.
                Sulle pagine secondarie (PropertyDetail/{id}, sotto-percorsi)
                resta `navigate(-1)`. */}
            {location.pathname !== "/dashboard" && (() => {
              const topLevelPaths = new Set([
                "/dashboard/assistente",
                "/dashboard/annunci",
                "/dashboard/sopralluogo",
                "/dashboard/agenda",
                "/dashboard/contatti",
                "/dashboard/import-gestionale",
                "/dashboard/foto",
                "/dashboard/galleria",
                "/dashboard/social",
                "/dashboard/contenuti",
                "/dashboard/portali",
                "/dashboard/stima",
                "/dashboard/agenzia",
                "/dashboard/radar",
                "/dashboard/profile",
                "/dashboard/referrals",
                "/dashboard/live",
              ]);
              const isTopLevel = topLevelPaths.has(location.pathname);
              return (
                <button
                  onClick={() => isTopLevel ? navigate("/dashboard") : navigate(-1)}
                  className="inline-flex items-center gap-1 px-2.5 py-1.5 -ml-1 rounded-md text-[12.5px] text-[#1C1C1A] hover:bg-[#EDEAE2] active:bg-[#E5E1D5] transition-colors"
                  aria-label={isTopLevel ? "Torna alla Home" : "Torna indietro"}
                  data-testid="topbar-back-btn"
                >
                  <CaretLeft size={14} weight="bold" />
                  <span className="hidden sm:inline">{isTopLevel ? "Home" : "Indietro"}</span>
                </button>
              );
            })()}
            <Link
              to="/dashboard"
              className="lg:hidden absolute left-1/2 -translate-x-1/2 flex items-center gap-1"
              style={isNative ? { top: "calc(env(safe-area-inset-top) + 6px)" } : { top: "10px" }}
              data-testid="topbar-brand"
            >
              {/* iter v29 r245 — User M1400: «P verde centrata anche dentro
                  l'app». Brand mark assoluto al centro del topbar mobile,
                  niente più allineamento a sinistra accanto all'hamburger. */}
              <img
                src="/logo/mark-symbol.png"
                alt="Pronto"
                className="h-7 w-7 select-none"
                draggable="false"
              />
            </Link>
            <div className="hidden lg:flex items-center gap-2 text-[13px] text-[#6B6A65] truncate" data-testid="topbar-breadcrumb">
              <span>Workspace</span>
              <span className="text-[#C8C5BD]">›</span>
              <span className="text-[#1C1C1A] font-medium truncate">{breadcrumb || title || "Pronto"}</span>
            </div>
          </div>

          <div className="flex items-center gap-2">
            {/* iter v29 r210 — Widget crediti compatto (mobile + desktop) */}
            <CreditsBadge />
            {/* iter v29 r105 — Trigger Cmd+K search globale.
                Su desktop: bottone con "scorciatoia". Su mobile: solo icona. */}
            <button
              onClick={() => {
                // Sintetizza l'evento Cmd+K che il palette intercetta
                const ev = new KeyboardEvent("keydown", { key: "k", metaKey: true, ctrlKey: true, bubbles: true });
                window.dispatchEvent(ev);
              }}
              className="inline-flex items-center gap-2 px-2.5 sm:px-3 py-1.5 bg-white border border-[#E5E7E0] hover:border-[#7C8B6E] text-[#6B6A65] hover:text-[#1C1C1A] text-[12px] font-medium rounded-md transition-colors"
              data-testid="topbar-search-btn"
              aria-label="Cerca"
            >
              <MagnifyingGlass size={14} />
              <span className="hidden sm:inline">Cerca…</span>
              <kbd className="hidden lg:inline-flex items-center text-[9.5px] tracking-wider font-semibold bg-[#F5F4EF] border border-[#E5E7E0] rounded px-1 py-0.5 text-[#9A968B]">⌘K</kbd>
            </button>
            {(() => {
              // iter 275: il fallback "+ Nuovo" era hardcoded a `/property/new`
              // su TUTTE le pagine — su Galleria mostrava "Nuovo" ma portava
              // ad Annunci, su Editor foto idem. Utente confuso. Ora lo
              // mostriamo solo dove ha senso (lista Annunci) o se la pagina
              // ha passato un `action` custom.
              // iter 275: il bottone "+ Nuovo annuncio" in topbar è
              // ridondante con la card "Crea annuncio" già presente nella Home.
              // Lo mostriamo solo nella lista `/dashboard/annunci`.
              const showNewListing = location.pathname === "/dashboard/annunci";
              if (action) return action;
              if (!showNewListing) return null;
              return (
                <button
                  onClick={() => navigate("/dashboard/property/new")}
                  className="bg-[#1C1C1A] hover:bg-black text-white text-[12px] font-medium px-3.5 py-2.5 sm:py-1.5 rounded-md inline-flex items-center gap-1.5 transition-colors"
                  data-testid="topbar-new-btn"
                >
                  <Plus size={13} weight="bold" />
                  <span className="hidden sm:inline">Nuovo annuncio</span>
                  <span className="sm:hidden">Nuovo</span>
                </button>
              );
            })()}
          </div>
        </header>

        {/* Page content */}
        <main
          className="flex-1 px-4 lg:px-8 py-3 lg:py-8 max-w-[1400px] w-full mx-auto"
          data-testid="app-main"
          style={isNative ? {
            // iter v29 r218 — Padding-bottom per non finire sotto BottomTabBar
            // (5rem = 80px circa = altezza tab bar + safe area home-indicator).
            // iter v32 r30 — Su Assistente la BottomTabBar è nascosta: niente
            // padding extra in fondo, l'input chat tocca la safe-area direttamente.
            paddingBottom: location.pathname.startsWith("/dashboard/assistente")
              ? "env(safe-area-inset-bottom)"
              : "calc(5rem + env(safe-area-inset-bottom))",
          } : undefined}
        >
          <EmailVerificationBanner />
          {children}
        </main>
      </div>
      {/* iter v29 r218 — Bottom tab bar nativa iOS (solo mobile native via Capacitor) */}
      {/* iter v29 r232 — Wrappato in ErrorBoundary silent: dopo l'incidente
          HMR del 7 giu (utente Luca B. → "Can't find variable: BottomTabBar"
          su /dashboard, schermo bianco), proteggiamo la dashboard da
          qualsiasi crash transient sulla tab bar. Se BottomTabBar fallisce
          → la dashboard resta usabile, niente fullscreen error. */}
      <ErrorBoundary silent>
        <BottomTabBar />
      </ErrorBoundary>
      {/* iter 309 r2: OnboardingExperience disabilitato — conflitto con
          OnboardingMagico (montato in Home.jsx, più aggiornato a 5 slide).
          L'auto-open su utente fresh ora avviene solo via OnboardingMagico. */}
      {/* <OnboardingExperience /> */}
      {/* MandatoOnboardingModal disabilitato iter 240: parlava di "landing personale per
          acquisizione mandati", in conflitto con la nuova strategia (niente più "mandati"
          come messaggio principale). Sostituito dalla checklist onboarding home + dal
          chip Stima "Volantino QR per il cliente" sulla landing. */}
      {/* <MandatoOnboardingModal /> */}
      {/* "Parla a Pronto" — global FAB, available on every dashboard page
          except Agenda/Drive/Sopralluogo (those have their own mic UI). */}
      {/* iter 275: rimosso <GlobalMicFab /> da qui — è già renderizzato a
          livello globale in App.js dentro AuthProvider, quindi avere anche
          questo in AppShell creava un duplicato del DOM (2 elementi con
          stesso data-testid). */}
      {/* iter v28 r423 — User M1333: notifica globale quando una foto live
          (enhance/restyle/empty-room/stage) è pronta mentre l'utente ha
          cambiato sezione. Polling silent /live/history ogni 8s. */}
      {/* iter v32 r37u · User M1453 — Annuncio "sito personale" one-time
          per PRO senza slug. Dismiss permanente via localStorage. */}
      <SitoPersonaleIntroModal />
      <LiveGenerationToaster />
      {/* iter v33 r62 · CreatingAnnuncioBanner globale: mostra progresso
          dell'annuncio in creazione post-sopralluogo su tutte le pagine
          dashboard tranne il PropertyDetail dell'annuncio stesso. */}
      <CreatingAnnuncioBanner />
      {/* iter v29 r199 — RIMOSSO IOSInstallBanner. Pronto ora ha l'app
          nativa su App Store: suggerire "aggiungi alla home" come PWA è
          fuori contesto. Su web Safari mobile useremo lo Smart App Banner
          ufficiale Apple via meta tag quando avremo l'App Store ID live. */}
      {/* iter v29 r105 — Cmd+K / Ctrl+K palette globale per cercare su
          annunci, contatti e agenda in un colpo solo. */}
      <GlobalSearchPalette />
    </div>
  );
}
